import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Login from './components/Login';
import EmailClient from './components/EmailClient';
import BlogManager from './components/BlogManager';
import './styles/globals.css';
import './styles/buttons.css';
import './styles/forms.css';

const LOGGED_IN_KEY = 'rpr_admin_logged_in';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentView, setCurrentView] = useState('blogs');

  useEffect(() => {
    // Check if user is already logged in
    const loggedIn = sessionStorage.getItem(LOGGED_IN_KEY);
    if (loggedIn === 'true') {
      setIsLoggedIn(true);
    }
  }, []);

  const handleLogin = () => {
    sessionStorage.setItem(LOGGED_IN_KEY, 'true');
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem(LOGGED_IN_KEY);
    setIsLoggedIn(false);
    setCurrentView('blogs');
  };

  const handleNavigate = (view) => {
    setCurrentView(view);
  };

  if (!isLoggedIn) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="app">
      <Header
        onNavigate={handleNavigate}
        currentView={currentView}
        onLogout={handleLogout}
      />
      <main>
        {currentView === 'blogs' && <BlogManager />}
        {currentView === 'email' && <EmailClient />}
      </main>
    </div>
  );
}

export default App;